import { useUpdateEffect } from 'react-use';

import { ReceptionServiceWithPractitionersSimpleQuery } from '@dreryk/egabinet-private-medical-service-frontend-api';
import { ReceptionServiceId } from '@dreryk/egabinet-private-medical-service-published-language-api';

import { refetchCqrsQuery } from '@dreryk/command-query-react-common';
import { useBoolean } from '@dreryk/react-common';

import { ReceptionServiceUpdateModal } from './ReceptionServiceUpdateModal';

type ReceptionServiceUpdateModalOpenerRenderer = (renderProps: { openModal: VoidFunction }) => JSX.Element;

type ReceptionServiceUpdateModalOpenerProps = {
   readonly children: ReceptionServiceUpdateModalOpenerRenderer;
   readonly receptionServiceId: ReceptionServiceId;
};

export const ReceptionServiceUpdateModalOpener = (props: ReceptionServiceUpdateModalOpenerProps): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean(false);

   useUpdateEffect(() => {
      if (!modalOpened) {
         refetchCqrsQuery(ReceptionServiceWithPractitionersSimpleQuery);
      }
   }, [modalOpened]);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}
         {modalOpened ? (
            <ReceptionServiceUpdateModal
               receptionServiceId={props.receptionServiceId}
               onSuccess={closeModal}
               onClose={closeModal}
            />
         ) : null}
      </>
   );
};
